(function () {

    // DOMContentLoaded ka wait hataya — jab tak yeh script chalti hai,
    // #bundle-builder div aur "Bundle Quantity" fieldset dono pehlay
    // hi DOM me maujood hotay hain, is liye foran chalna safe hai.
    // Isi se builder foran (instantly) load/render hota hai.
    const builder = document.getElementById("bundle-builder");

    if (!builder) return;

    class BundleBuilder {

        constructor(element) {

            this.el = element;

            this.colors = JSON.parse(this.el.dataset.colors || "[]");
            this.sizes = JSON.parse(this.el.dataset.sizes || "[]");
            this.bundleName = this.el.dataset.bundleName || "T-Shirt";
            this.poCode = this.el.dataset.poCode || "";
            this.showProgress = this.el.dataset.showProgress !== "false";
            this.selectionStyle = this.el.dataset.selectionStyle || "accordion";

            this.summary = document.getElementById("bundle-summary");
            this.items = document.getElementById("bundle-items");
            this.properties = document.getElementById("bundle-properties");
            // NOTE: form.shopify-product-form is rendered AFTER this
            // snippet in the page (buy-buttons block comes later in
            // block order) — is liye yahan CACHE nahi karte, har dafa
            // getProductForm() se fresh dhoondtay hain (dekhein neechay).
            this.bundleQty = 0;
            this.state = [];
            this.activeCard = 1;
            this.manualEdit = false;

            // Builder abhi ready nahi — Add to Cart / Buy Now dono
            // locked rehnay chahiye jab tak selection complete na ho.
            // (CSS default state se hi lock karta hai, yeh sirf safety hai)
            document.documentElement.classList.remove("bb-ready");

            this.init();

        }

        init() {

    this.findBundlePicker();

    this.bindBundleEvents();

    this.exposeGuardAPI();

    this.updateBundle();

    document.addEventListener("click", (e) => {
        if (!e.target.closest(".bb-dd")) {
            this.closeAllDropdowns();
        }
    });

}

        // Inline guard script (jo section me turant chalta hai) is API
        // ko use karta hai. Class load honay se pehlay yeh API "always
        // invalid" hoti hai (default stub), yahan hum usay asal
        // validation aur detailed per-card error highlighting se jor
        // detay hain.
        exposeGuardAPI() {

            window.BundleBuilderAPI = {
                isValid: () => this.validateBundle(),
                showErrors: () => this.showErrors()
            };

        }

        // Add to Cart / Buy Now ko sirf tab clickable karta hai
        // jab selection mukammal ho. Button ko "disabled" nahi karta,
        // bs pointer-events lock/unlock karta hai (CSS: .bb-ready).
        updateLockState() {

            const isValid = this.validateBundle();

            document.documentElement.classList.toggle("bb-ready", isValid);

            return isValid;

        }

        findBundlePicker() {

            this.bundleFieldset = document.querySelector(
                'fieldset[data-option-id*="bundle-quantity"]'
            );

            if (!this.bundleFieldset) {

                console.error("Bundle fieldset not found");

                return;

            }

            this.bundleInputs =
                this.bundleFieldset.querySelectorAll('input[type="radio"]');

        }

        bindBundleEvents() {

            this.bundleInputs.forEach(input => {

                input.addEventListener("change", () => {

                    this.updateBundle();

                });

            });

        }

        updateBundle() {
                this.manualEdit = false;


            const selected =
                this.bundleFieldset.querySelector("input[type='radio']:checked");

            if (!selected) return;

            // "Bundle of 3" jaisay pattern ko priority detay hain
            // (zyada reliable), warna jo bhi pehla number mile wo
            // le lete hain. Kabhi bhi crash nahi hona chahiye chahay
            // koi bhi text/naming convention product pe ho.
            const text = selected.value || "";
            const ofMatch = text.match(/(?:of|x|×)\s*(\d+)/i);
            const anyMatch = text.match(/\d+/);
            const qty = ofMatch ? parseInt(ofMatch[1], 10)
                : anyMatch ? parseInt(anyMatch[0], 10)
                : null;

            if (!qty || isNaN(qty) || qty < 1) {
                console.error(
                    "Bundle Builder: bundle quantity ka pata nahi chal saka is text se: '" + text + "'."
                );
                return;
            }

            this.bundleQty = qty;

            this.createState();

            this.render();
            this.updateLockState();

        }

        createState() {

    const oldState = [...this.state];

    this.state = [];

    for (let i = 0; i < this.bundleQty; i++) {

        this.state.push({

            index: i + 1,

            color: oldState[i]?.color || "",

            size: oldState[i]?.size || ""

        });

    }

}

        render() {

            this.renderSummary();

            this.renderCards();

        }

        renderSummary() {

    if (this.showProgress === false) {
        this.summary.innerHTML = "";
        return;
    }

    const completed = this.state.filter(item =>
    item.color && item.size
).length;

const percent = (completed / this.bundleQty) * 100;

this.summary.innerHTML = `

<div class="bb-summary">

    <div class="bb-progress-header">

        <span>Bundle Progress</span>

        <strong>${completed} / ${this.bundleQty}</strong>

    </div>

    <div class="bb-progress">

        <div
            class="bb-progress-fill"
            style="width:${percent}%">
        </div>

    </div>

</div>

`;

}

renderCards() {

            this.items.innerHTML = "";

            if (this.selectionStyle === "dropdown") {
                this.items.appendChild(this.createDropdownGrid());
                return;
            }

            this.state.forEach(item => {

                this.items.appendChild(

                    this.createCard(item)

                );

            });

        }

        createCard(item) {

            const card = document.createElement("div");

card.className = "bundle-item";

if(item.index === this.activeCard){

    card.classList.add("active");

}

            card.dataset.index = item.index;

            const title = document.createElement("div");

title.className = "bundle-summary-title";

const status = this.getStatus(item);

title.innerHTML = `
<div class="bundle-header">

    <div class="bundle-header-left">

        <span class="bb-item-title">
            ${this.bundleName} #${item.index}
        </span>

        ${item.color || item.size ? `
        <div class="bundle-preview">

            ${item.color ? `
            <span class="bundle-preview-color">

                <span class="bundle-preview-swatch"
                    style="background:${item.color}">
                </span>

                ${this.colors.find(c => c.color === item.color)?.color_name || item.color}

            </span>
            ` : ""}

            ${item.color && item.size ? `<span class="bundle-preview-dot">•</span>` : ""}

            ${item.size ? `
            <span class="bundle-preview-size">
                ${item.size}
            </span>
            ` : ""}

        </div>
        ` : ""}

    </div>

    <span class="bundle-status ${status.class}">
        ${status.text}
    </span>

    <span class="bundle-arrow">▼</span>

</div>
`;

            const colorWrapper =
                document.createElement("div");

            colorWrapper.className = "bb-field bb-field--color";

            const colorLabel =
                document.createElement("label");

            const currentColor = this.state[item.index - 1].color;

const selectedColor = this.colors.find(c => c.color === currentColor);

colorLabel.innerHTML = `<span>Color :</span>`;

            const colorSelect =
                this.createColorSelect(item.index);

            colorWrapper.appendChild(colorLabel);

            colorWrapper.appendChild(colorSelect);

            const sizeWrapper =
                document.createElement("div");

            sizeWrapper.className = "bb-field bb-field--size";

            const sizeLabel =
                document.createElement("label");

            const currentSize = this.state[item.index - 1].size;

sizeLabel.innerHTML = `<span>Size :</span>`;

            const sizeSelect =
    this.createSizeButtons(item.index);

            sizeWrapper.appendChild(sizeLabel);

            sizeWrapper.appendChild(sizeSelect);

            const body = document.createElement("div");

body.className = "bundle-body";

body.appendChild(colorWrapper);

body.appendChild(sizeWrapper);
title.style.cursor = "pointer";

title.addEventListener("click", () => {

    this.manualEdit = true;

    if (this.activeCard === item.index) {
        this.activeCard = 0;
    } else {
        this.activeCard = item.index;
    }

    this.render();

});

card.appendChild(title);

card.appendChild(body);

            return card;

        }

        // ============================================================
        // DROPDOWN MODE — Accordion k bagair. Har T-Shirt k liye Color
        // aur Size dropdown, sab ek 2-column grid mein sequence se:
        // T1-Color, T1-Size, T2-Color, T2-Size, ...
        // ============================================================
        createDropdownGrid() {

            const grid = document.createElement("div");
            grid.className = "bb-dropdown-grid";

            this.state.forEach(item => {

                const label = document.createElement("div");
                label.className = "bb-dd-item-label";
                label.textContent = `${this.bundleName} #${item.index}`;
                grid.appendChild(label);
                label.style.display = "none"; // sirf error-scroll target k liye rakha, heading nahi chahiye thi

                grid.appendChild(this.createColorDropdownCustom(item.index));
                grid.appendChild(this.createSizeDropdownCustom(item.index));

            });

            return grid;

        }

        // Sab khuli hui dropdowns band kar deta hai (ek waqt mein sirf
        // ek hi khuli rahay).
        closeAllDropdowns(except) {
            document.querySelectorAll(".bb-dd.bb-dd--open").forEach(dd => {
                if (dd !== except) dd.classList.remove("bb-dd--open");
            });
        }

        createColorDropdownCustom(index) {

            const currentValue = this.state[index - 1].color;
            const selectedColor = this.colors.find(c => c.color === currentValue);

            const dd = document.createElement("div");
            dd.className = "bb-dd bb-dd--color";
            dd.dataset.index = index;
            dd.dataset.field = "color";

            const trigger = document.createElement("button");
            trigger.type = "button";
            trigger.className = "bb-dd-trigger";
            trigger.innerHTML = selectedColor
                ? `<span class="bb-dd-swatch" style="background:${selectedColor.color}"></span><span class="bb-dd-trigger-text">${selectedColor.color_name}</span>`
                : `<span class="bb-dd-trigger-text bb-dd-placeholder">Select Color #${index}</span>`;
            trigger.insertAdjacentHTML("beforeend", '<span class="bb-dd-chevron">▾</span>');

            const menu = document.createElement("div");
            menu.className = "bb-dd-menu";

            this.colors.forEach(color => {
                const option = document.createElement("button");
                option.type = "button";
                option.className = "bb-dd-option";
                if (currentValue === color.color) option.classList.add("bb-dd-option--active");
                option.innerHTML = `<span class="bb-dd-swatch" style="background:${color.color}"></span><span>${color.color_name}</span>`;
                option.addEventListener("click", () => {
                    this.updateState(index, "color", color.color);
                    dd.classList.remove("bb-dd--open");
                });
                menu.appendChild(option);
            });

            trigger.addEventListener("click", (e) => {
                e.stopPropagation();
                const willOpen = !dd.classList.contains("bb-dd--open");
                this.closeAllDropdowns(dd);
                dd.classList.toggle("bb-dd--open", willOpen);
            });

            dd.appendChild(trigger);
            dd.appendChild(menu);

            return dd;

        }

        createSizeDropdownCustom(index) {

            const currentValue = this.state[index - 1].size;

            const dd = document.createElement("div");
            dd.className = "bb-dd bb-dd--size";
            dd.dataset.index = index;
            dd.dataset.field = "size";

            const trigger = document.createElement("button");
            trigger.type = "button";
            trigger.className = "bb-dd-trigger";
            trigger.innerHTML = currentValue
                ? `<span class="bb-dd-trigger-text">${currentValue}</span>`
                : `<span class="bb-dd-trigger-text bb-dd-placeholder">Select Size #${index}</span>`;
            trigger.insertAdjacentHTML("beforeend", '<span class="bb-dd-chevron">▾</span>');

            const menu = document.createElement("div");
            menu.className = "bb-dd-menu";

            this.sizes.forEach(size => {
                const option = document.createElement("button");
                option.type = "button";
                option.className = "bb-dd-option";
                if (currentValue === size) option.classList.add("bb-dd-option--active");
                option.innerHTML = `<span>${size}</span>`;
                option.addEventListener("click", () => {
                    this.updateState(index, "size", size);
                    dd.classList.remove("bb-dd--open");
                });
                menu.appendChild(option);
            });

            trigger.addEventListener("click", (e) => {
                e.stopPropagation();
                const willOpen = !dd.classList.contains("bb-dd--open");
                this.closeAllDropdowns(dd);
                dd.classList.toggle("bb-dd--open", willOpen);
            });

            dd.appendChild(trigger);
            dd.appendChild(menu);

            return dd;

        }

        createColorSelect(index) {

            const select = document.createElement("select");

            select.className = "bb-select";

            select.dataset.index = index;

            select.dataset.type = "color";

            const placeholder =
                document.createElement("option");

            placeholder.value = "";

            placeholder.textContent = "Select Color";

            select.appendChild(placeholder);

            const currentValue = this.state[index - 1].color;

            const swatches = document.createElement("div");

            swatches.className = "bb-swatches";
           
            this.colors.forEach(color => {

    const option = document.createElement("option");

    option.value = color.color;

    option.textContent = `${color.color_name} (${color.color})`;

    if (currentValue === color.color) {

        option.selected = true;

    }

    select.appendChild(option);

    // 👇 Swatch hamesha banega
    const swatch = document.createElement("button");

    swatch.type = "button";

    swatch.className = "bb-swatch";

    swatch.title = color.color_name;

    swatch.style.backgroundColor = color.color;

    if (currentValue === color.color) {

        swatch.classList.add("active");

    }

    swatch.addEventListener("click", () => {

        select.value = color.color;

        select.dispatchEvent(new Event("change"));

    });

    swatches.appendChild(swatch);

});

            select.addEventListener("change", (e) => {

                this.updateState(

                    index,

                    "color",

                    e.target.value

                );

            });

            const wrapper = document.createElement("div");

wrapper.className = "bb-color-picker";

wrapper.appendChild(swatches);

wrapper.appendChild(select);

return wrapper;

        }

        createSizeButtons(index) {

    const wrapper = document.createElement("div");

    wrapper.className = "bb-size-buttons";

    const currentValue = this.state[index - 1].size;

    this.sizes.forEach(size => {

        const btn = document.createElement("button");

        btn.type = "button";

        btn.className = "bb-size-btn";

        btn.textContent = size;

        if (currentValue === size) {

            btn.classList.add("active");

        }

        btn.addEventListener("click", (e) => {

    e.preventDefault();

    this.updateState(index, "size", size);

});

        wrapper.appendChild(btn);

    });

    return wrapper;

}

        updateState(index, field, value) {

    const row = this.state[index - 1];

    row[field] = value;
    if (row.color && row.size) {

    // Agar user edit kar raha hai to auto-switch mat karo
    if (!this.manualEdit) {

        if (index < this.bundleQty) {
            this.activeCard = index + 1;
        } else {
            this.activeCard = 0;
        }

    }

}
    const card = document.querySelector(
    `.bundle-item[data-index="${index}"]`
);

if(card){

    const selects = card.querySelectorAll(".bb-select");

    if(field === "color"){
        selects[0].classList.remove("bb-error");
    }

    if(field === "size"){
       // selects[1].classList.remove("bb-error");
    }

}

this.renderProperties();

this.render();

this.updateLockState();

}

        renderProperties() {

    this.properties.innerHTML = "";

    this.state.forEach((item) => {

    if (!item.color || !item.size) return;

    const color = this.colors.find(
        c => c.color === item.color
    );

    const colorName = color?.color_name || item.color;

    // Key = "T-Shirt N" (bundleName + index — hamesha unique).
    // Value = "DT | Color | Size" (agar po_code set ho), warna
    // sirf "Color | Size".
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = `properties[${this.bundleName} ${item.index}]`;
    input.value = this.poCode
        ? `${this.poCode} | ${colorName} | ${item.size}`
        : `${colorName} | ${item.size}`;
    this.properties.appendChild(input);

});

    // Fresh lookup — construction k waqt yeh form abhi DOM me nahi
    // hota (buy-buttons block bundle-builder k BAAD render hota hai),
    // is liye yahan har dafa dobara dhoondtay hain.
    const productForm = document.querySelector("form.shopify-product-form");

    if (productForm && this.properties.parentNode !== productForm) {

        productForm.appendChild(this.properties);

    }

}
getStatus(item) {

    if (!item.color && !item.size) {

        return {
            text: "Required",
            class: "status-required"
        };

    }

    if (item.color && !item.size) {

        return {
            text: "Select Size",
            class: "status-pending"
        };

    }

    if (!item.color && item.size) {

        return {
            text: "Select Color",
            class: "status-pending"
        };

    }

    return {

        text: "✓ Complete",
        class: "status-complete"

    };

}
validateBundle() {

    // Jab tak bundle quantity select nahi hoti (state khali hai),
    // isay "valid" nahi maanna — warna Add to Cart / Buy Now
    // builder load honay se pehlay hi unlock ho jatay hain.
    if (!this.bundleQty || this.state.length === 0) {
        return false;
    }

    return this.state.every(item =>
        item.color && item.size
    );

}

showErrors() {

    if (this.selectionStyle === "dropdown") {
        this.showDropdownErrors();
        return;
    }

    let firstError = null;

    this.state.forEach(item => {

        const card = document.querySelector(
            `.bundle-item[data-index="${item.index}"]`
        );

        if (!card) return;

        const badge = card.querySelector(".bundle-status");
        const colorSelect = card.querySelector(".bb-select");
        const colorField = colorSelect?.closest(".bb-field");
        const sizeField = card.querySelectorAll(".bb-field")[1];

        card.classList.remove("bundle-error");
        badge.classList.remove("status-error");

        colorField?.classList.remove("bb-error");
        sizeField?.classList.remove("bb-error");
        const header = card.querySelector(".bundle-summary-title");
const body = card.querySelector(".bundle-body");

card.classList.remove("bb-card-error");
body?.classList.remove("bb-body-error");

        let hasError = false;

        if (!item.color || !item.size) {

    badge.classList.add("status-error");

    if(card.classList.contains("active")){

    card.classList.add("bb-card-error");

    const body = card.querySelector(".bundle-body");

    body?.classList.add("bb-body-error");

}else{

    card.classList.add("bb-card-error");

}

    if (!firstError) {

        firstError = card;

    }

}

    });

    if (firstError) {

        firstError.scrollIntoView({

            behavior: "smooth",
            block: "center"

        });

    }

}

showDropdownErrors() {

    let firstError = null;

    document.querySelectorAll(".bb-dd").forEach(dd => {
        dd.classList.remove("bb-dd--error");
    });

    this.state.forEach(item => {

        if (!item.color) {
            const dd = document.querySelector(`.bb-dd--color[data-index="${item.index}"]`);
            if (dd) {
                dd.classList.add("bb-dd--error");
                if (!firstError) firstError = dd;
            }
        }

        if (!item.size) {
            const dd = document.querySelector(`.bb-dd--size[data-index="${item.index}"]`);
            if (dd) {
                dd.classList.add("bb-dd--error");
                if (!firstError) firstError = dd;
            }
        }

    });

    if (firstError) {
        firstError.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }

}

} // <-- Class BundleBuilder yahan close hogi

new BundleBuilder(builder);

})();